// Assets
import carImage from "../assets/images/icon_graphic_neue_car.svg";
import keysImage from "../assets/images/icon_geanderter_status_yellow.svg";
import ablageImage from "../assets/images/ICON_Ablage_new.svg";

export const VORGANT_STATUS_FEHLER = "Fehler";
export const VORGANT_STATUS_FEHLER_B = "Fehler (B)";
export const VORGANT_STATUS_FEHLER_T = "Fehler (T)";
export const VORGANT_STATUS_VERSANDFERTIG = "Versandfertig";
export const VORGANT_STATUS_GESPEICHERT = "Gespeichert";
export const VORGANT_STATUS_ABGELEHNT = "Abgelehnt";
export const VORGANT_STATUS_VERWORFEN = "Verworfen";
export const VORGANT_STATUS_GENEHMIGT = "Genehmigt";
export const VORGANT_STATUS_EINGEREICHT = "Eingereicht";
export const STATUSARR = {
  Abgelehnt: "Abgelehnt",
  Verworfen: "Verworfen",
  Genehmigt: "Genehmigt",
  Gespeichert: "Gespeichert",
  Versandfertig: "Versandfertig",
  Eingereicht: "Eingereicht",
  Fehler: "Fehler",
  "Fehler (B)": "Fehler (B)",
  "Fehler (T)": "Fehler (T)",
};
export const GKS_STATUS_ARR = {
  Abgelehnt: "Abgelehnt",
  Genehmigt: "Genehmigt",
};
export const TILES_LABEL = {
  ready: "Versandfertige Anträge",
  antrage: "Anträge",
  cache: "Zwischenspeicher",
};
export const REQUEST_TYPES = [
  "NZ",
  "AB",
  "UM",
  "UG",
  "WZ",
  "WG",
  "TZ",
  "HA",
  "SO",
];
export const REQUESTS_TYPE_DISPLAY_NAMES = {
  NZ: "Neuzulassung",
  AB: "Außerbetriebsetzung",
  UM: "Ummeldung (alt)",
  UG: "Umschreibung (UG)",
  WZ: "Wiederzulassung (WZ)",
  WG: "Wiederzulassung (WG)",
  TZ: "Tageszulassung",
  HA: "Namens- oder Adressänderung des Halters",
  SO: "Offen",
};
export const appLoginDashboardTabsLabels = [
  {
    buttonLabel: "Mandantenverwaltung",
    buttonId: "Mandantenverwaltung",
    toolTipLabel: "",
  },
  {
    buttonLabel: "Gebührenreport",
    buttonId: "Gebührenreport",
    toolTipLabel: "",
  },
];

export const pluginsTabsLabels = [
  {
    buttonLabel: "Plugins",
    buttonId: "Plugins",
    toolTipLabel: "",
  },
];

export const ERROR_MESSAGES = [
  "Die hochzuladende Datei darf nicht größer sein, als 8MB. Bitte wählen Sie eine kleinere Datei aus.",
  "Bitte wählen Sie eine CSV-Datei aus, um diese hochzuladen.",
  "Falscher Dateityp. Bitte laden Sie eine CSV-Datei hoch.",
  "Ihre Anträge wurden erfolgreich in die Vorgangsliste geladen. Sie können diese nun bearbeiten und absenden.", //Information message when request is uploaded.
];
export const DASH_DOWNLOAD_EXCEL_ERROR =
  "Bitte wählen Sie mindestens einen Eintrag aus, um die Download Funktionalität zu nutzen.";
export const READ_RECORD_ERROR =
  "Es tut uns leid! Es ist ein Fehler  bei der Statusabfrage aufgetreten. Bitte versuchen Sie es später noch einmal.";
export const DASH_NO_SELECT_ERROR =
  "Bitte wählen Sie mindestens einen Eintrag aus, um die gewünschte Funktionalität zu nutzen.";
export const CLEAR_FILTER_SUCCESS_MESSAGE = "Filter sind zurückgesetzt.";
export const DASH_NO_NEU_ERROR =
  'Bitte wählen Sie einen Vorgang mit dem Status "Versandfertig" aus, um diesen weiterzuleiten.';
export const DASH_DUPLICATE_ERROR =
  "Der ausgewählte Antrag enthält noch Aktualisierungen, bitte nehmen Sie diese an oder verwerfen Sie diese, um den Antrag einreichen zu können.";
export const DASH_NO_TEIL_ERROR =
  'Bitte wählen Sie einen Vorgang mit dem Status "Eingereicht" aus, um dessen Status abzurufen';
export const DASH_NO_NEU_ABLAGE_ERROR =
  'Bitte wählen Sie einen Vorgang mit dem Status "Versandfertig" oder "Gespeichert" aus, um diesen auszusondern.';
export const DASH_NO_NEU_EDIT_ERROR =
  'Bitte wählen Sie nur einen Vorgang, der nicht im Status "Eingereicht" ist oder keine Antragsnummer hat.';
export const DASH_ONLY_ONE_NEU_EDIT_ERROR =
  'Bitte wählen Sie nur einen Prozess mit dem Status "Versandfertig" aus, um ihn zu bearbeiten.';
export const DASH_GKS_NOT_ALLOWED =
  "Dieser Vorgang wurde über die zentrale Schnittstelle an das KBA versandt, somit ist keine Statusabfrage nötig.";
export const VORGANG_ID_NOT_FOUND =
  "Der von Ihnen ausgewählte Antrag liegt nicht vor.";
export const VORGANG_MAX_SELECTION_LIMIT_ERROR =
  "Sie haben die maximale Antragsauswahl von 200 überschritten. Bitte überprüfen Sie Ihre Auswahl.";
export const getMaxSelectionLimitError = (maxLimit) => {
  return `Sie haben die maximale Antragsauswahl von ${maxLimit} überschritten. Bitte überprüfen Sie Ihre Auswahl.`;
};

export const FILETYPE_VALIDATIONS =
  "Bitte wählen Sie eine CSV-Datei aus, um diese hochzuladen.";
export const VORGANG_NO_DATA_FOUND =
  "Leider können zu Ihrer Suchanfrage keine Ergebnisse gefunden werden. Möglicherweise befinden sich Vorgänge zu Ihrer Suche im Archiv.";
export const GET_TILEDETAILS_SUCCESS = "GET_TILEDETAILS_SUCCESS";
export const GET_FEE_TILEDETAILS_SUCCESS = "GET_FEE_TILEDETAILS_SUCCESS";
export const GET_ARCHIV_STATISTICS_SUCCESS = "GET_ARCHIV_STATISTICS_SUCCESS";
export const GET_TENANT_TABLE_DATA_SUCCESS = "GET_TENANT_TABLE_DATA_SUCCESS";
export const GET_TECHNICAL_ALIAS_SUCCESS = "GET_TECHNICAL_ALIAS_SUCCESS";
export const GET_TENTANT_GROUPS_SUCCESS = "GET_TENTANT_GROUPS_SUCCESS";
export const GET_FEE_REPORTING_TABLE_DATA_SUCCESS =
  "GET_FEE_REPORTING_TABLE_DATA_SUCCESS";
export const GET_TENANTS_REQUEST_TYPES_SUCCESS =
  "GET_TENANTS_REQUEST_TYPES_SUCCESS";
export const CREATE_TENANTS_STATUS = "CREATE_TENANTS_STATUS";
export const tableColors = {
  rowSelected: "#00C4DE",
  rowBackground: "#fff",
  leftBorderColor: "#FFF",
  rowDisabled: "#E6E6E6",
  rowRegistrationMismatchedColor: "#FEF2F2",
};
export const abrechnungstypFilterOption = {
  Großkunde: "Großkunde",
  Zulassungsbehörde: "Zulassungsbehörde",
};
export const monthOptions = [
  { label: "Januar", value: 1 },
  { label: "Februar", value: 2 },
  { label: "März", value: 3 },
  { label: "April", value: 4 },
  { label: "Mai", value: 5 },
  { label: "Juni", value: 6 },
  { label: "Juli", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "Oktober", value: 10 },
  { label: "November", value: 11 },
  { label: "Dezember", value: 12 },
];
export const ZENDESK_LINK =
  "https://mydigitalcar.zendesk.com/auth/v2/login/signin?auth_origin=24676280493457%2Cfalse%2Ctrue&brand_id=24676280493457&locale=8&return_to=https%3A%2F%2Fmydigitalcar.zendesk.com%2Fagent&role=consumer&theme=hc";
export const APP_DASHBOARD_IN_COMPLETE_TENANT_PROFILE =
  "Bitte wählen Sie ausschließlich vollständige Profile für den Export aus.";

export const DASHBOARD_TILES_DEFAULT_DATA = {
  newRocordsStatistics: {
    imageURL: carImage,
    label: "Versandfertige Anträge",
    count: 0,
    statistics: [
      { displayName: "Neuzulassungen", value: "NZ", count: 0 },
      { displayName: "Außerbetriebsetzung", value: "AB", count: 0 },
      { displayName: "Ummeldungen", value: "UM", count: 0 },
    ],
  },
  statusStatistics: {
    imageURL: keysImage,
    label: "Anträge",
    count: 0,
    statistics: [
      { displayName: "Versandfertig", value: "Versandfertig", count: 0 },
      { displayName: "Eingereicht", value: "Eingereicht", count: 0 },
      { displayName: "Genehmigt", value: "Genehmigt", count: 0 },
      { displayName: "Abgelehnt", value: "Abgelehnt", count: 0 },
      { displayName: "Verworfen", value: "Verworfen", count: 0 },
    ],
  },
  inAblageRocordsStatistics: {
    imageURL: ablageImage,
    label: "Zwischenspeicher",
    count: 0,
    statistics: [
      { displayName: "Neuzulassungen", value: "NZ", count: 0 },
      { displayName: "Außerbetriebsetzung", value: "AB", count: 0 },
      { displayName: "Ummeldungen", value: "UM", count: 0 },
      { displayName: "Offen", value: "SO", count: 0 },
    ],
  },
};
